import React from 'react';
import { Form } from 'antd';
import { FilterBar2Value, FilterContentProps } from '../types';
import Radio from 'components/radio/radio';

interface RadioFilterContentProps extends FilterContentProps {
	customAllAsOption?: {
		label: string;
	};
}

export const FilterContentRadio = ({ name, values, onFilterChange, customAllAsOption }: RadioFilterContentProps) => (
	<Form.Item name={name}>
		<Radio.Group>
			{customAllAsOption && (
				<div className="filter-bar-2-base-row">
					{/*This will be selected by default when no initial values as this is how the form works*/}
					<Radio value={undefined} onChange={onFilterChange}>
						{customAllAsOption.label}
					</Radio>
				</div>
			)}
			{(values as FilterBar2Value[]).map(item => (
				<div className="filter-bar-2-base-row" key={item.value}>
					<Radio value={item.value} onChange={onFilterChange}>
						{item.label}
					</Radio>
				</div>
			))}
		</Radio.Group>
	</Form.Item>
);
